module.exports = __webpack_public_path__ + "img/7.118186ae.svg";